import type { FieldPath, FieldValues } from "react-hook-form"
import { useFormContext } from "react-hook-form"
import { _get } from "@/utils"

const getMessage = (value: unknown): string | undefined => {
  if (!value || typeof value !== "object") {
    return
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const result = getMessage(item)
      if (result) {
        return result
      }
    }

    return
  }

  for (const [key, val] of Object.entries(value)) {
    if (key === "message" && typeof val === "string") {
      return val
    }
    const result = getMessage(val)
    if (result) {
      return result
    }
  }
}

export default <TValues extends FieldValues>(fieldName: FieldPath<TValues>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<TValues>()

  const formError = errors.root?.formError?.message

  const error = getMessage(_get(fieldName.split("."), errors))

  return {
    control,
    isError: !!error || !!formError,
    error,
  }
}
